import React, { useMemo } from "react";
import { startOfWeek, addDays, sameDay, fmtHM } from "@/lib/time";

// Month grid: events + task blocks + all-day, "+N" overflow, click day → Day view.
export default function MonthGrid({ anchor, items, onDayClick, onItemClick }) {
  const first = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
  const start = startOfWeek(first);
  const weeks = useMemo(() => Array.from({ length: 6 }, (_, w) => Array.from({ length: 7 }, (_, d) => addDays(start, w * 7 + d))), [start]);
  const today = new Date();
  const byDay = (d) => items.filter((i) => i.allDay ? (i.startDate <= d && i.endDate > d) : sameDay(i.start, d))
    .sort((a, b) => (a.allDay ? -1 : b.allDay ? 1 : a.start - b.start));
  const cls = (i) => i.kind === "task_block" ? "text-indigo-200" : i.transparency === "free" ? "text-emerald-300/80" : i.provider === "google" ? "text-sky-200" : i.provider === "ics" ? "text-violet-200" : i.provider === "icloud" ? "text-pink-200" : "text-emerald-200";

  return (
    <div className="rounded-2xl border border-border bg-card overflow-hidden" data-testid="month-grid">
      <div className="grid grid-cols-7 border-b border-border">
        {["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"].map((l) => <div key={l} className="py-2 text-center font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{l}</div>)}
      </div>
      {weeks.map((week, wi) => (
        <div key={wi} className="grid grid-cols-7 border-b border-border last:border-b-0">
          {week.map((d) => {
            const dayItems = byDay(d);
            const other = d.getMonth() !== anchor.getMonth();
            const isToday = sameDay(d, today);
            return (
              <div key={d.toISOString()} data-testid={`month-day-${d.getDate()}${other ? "-other" : ""}`} onClick={() => onDayClick(d)}
                className={`min-h-[104px] border-l border-border first:border-l-0 p-1.5 cursor-pointer hover:bg-accent/40 transition-colors ${other ? "opacity-40" : ""} ${isToday ? "bg-primary/5" : ""}`}>
                <div className={`font-display text-sm font-semibold mb-1 ${isToday ? "text-primary" : ""}`}>{d.getDate()}</div>
                <div className="space-y-0.5">
                  {dayItems.slice(0, 3).map((i) => (
                    <div key={i.key} onClick={(e) => { e.stopPropagation(); onItemClick(i); }} className={`truncate text-[10px] leading-tight hover:underline ${cls(i)} ${i.done ? "line-through opacity-50" : ""}`} title={i.title}>
                      {!i.allDay && <span className="font-mono opacity-70">{fmtHM(i.start)} </span>}{i.transparency === "free" ? "○ " : ""}{i.title}
                    </div>
                  ))}
                  {dayItems.length > 3 && <div className="text-[10px] text-muted-foreground" data-testid="month-more">+{dayItems.length - 3} autres</div>}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
